<template>
  <div
    class="asset-relationship-node-box flex"
    :class="{ 'selected-node': selected }"
    style="width: 200px; height: 40px;"
    :title="`${node.name}${node.displayName ? `: ${node.displayName}` : ''}`"
  >
    <MIcon
      v-if="resourceIconName"
      size="lg"
      class="mr-3"
      :class="{ 'text-white': selected, 'text-neutral-light': !selected }"
      :name="resourceIconName"
    />
    <CustomIcon v-else :name="node.assetIconName" class="mr-3" size="lg" />
    <div class="min-w-0 flex-1 text-ellipsis">
      {{ node.name }}
      {{ node.displayName ? `: ${node.displayName}` : '' }}
    </div>
  </div>
</template>

<script>
import CustomIcon from '@components/custom-icon/custom-icon'

export default {
  name: 'GraphNode',
  components: { CustomIcon },
  props: {
    node: { type: Object, required: true },
    selected: { type: Boolean, default: false },
  },
  computed: {
    resourceIconName() {
      const model = this.node.model
      if (model === 'user') {
        return 'user'
      }
      if (model === 'user_group') {
        return 'users'
      }
      if (model === 'department') {
        return 'building'
      }
      return null
    },
  },
}
</script>
